import { LayoutGrid } from 'lucide-react';

interface TemplateIntroProps {
  title?: string;
  description?: string;
  disabled?: boolean;
}

export const TemplateIntro = ({ title, description, disabled = true }: TemplateIntroProps) => (
  <div className="w-full">
    {/* Header Section */}
    {title && (
      <div className="flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-[#C0275E] to-[#E84A7F] rounded-t-xl">
        <LayoutGrid size={20} className="text-white" />
        <h2 className="text-lg font-bold text-white tracking-wide">{title}</h2>
      </div>
    )}
  </div>
);
